<template>
  <!-- Header -->
  <div class="header" ref="header">
    <!-- Logo -->
    <div id="toggle_btn" v-if="miniSidebar" class="header-left">
      <!-- <router-link to="/admin-dashboard" class="logo2" > -->
      <div class="logo2">
        {{ appVariant }}
        <img
          v-if="appVariant === 'default'"
          src="@/assets/img/hcmlogo2.png"
          width="60"
          height="40"
          alt="Logo"
        />
        <img
          v-else-if="appVariant === 'appedology'"
          src="@/assets/img/appedolog-color-logo.svg"
          width="60"
          height="40"
          alt="Logo"
        />
        <img
          v-else
          src="@/assets/img/proglobal-color-logo.svg"
          width="60"
          height="40"
          alt="Logo"
        />
      </div>
      <!-- </router-link> -->
    </div>
    <div id="toggle_btn" v-else class="header-left">
      <router-link class="logo" to="/employee-dashboard">
        <img
          v-if="appVariant === 'default'"
          :src="logoSrc"
          width="170"
          height="40"
          style="margin-left: 20px;"
          alt="Logo"
        />
        <img
          v-else-if="appVariant === 'appedology'"
          src="@/assets/img/appedolog-color-logo.svg"
          style="
            margin-top: -70px;
            width: 220px;
            height: 220px;
            cursor: default;
          "
          alt="Logo"
        />
        <img
          v-else
          src="@/assets/img/proglobal-color-logo.svg"
          width="60"
          height="40"
          alt="Logo"
        />
        <!-- <img src="@/assets/img/meri-sehat-logo.svg" width="170" height="40" alt="Logo" /> -->
      </router-link>
      <!-- <router-link to="/admin-dashboard" class="logo"> -->
      <!-- </router-link> -->
    </div>
    <!-- /Logo -->

    <!-- <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a> -->

    <!-- Header Title -->
    <div class="page-title-box">
      <!-- <h3>Human Capital Management</h3> -->
    </div>
    <!-- /Header Title -->

    <a
      id="mobile_btn"
      class="mobile_btn"
      href="#sidebar"
      @click.prevent="toggleSidebar1"
      ><i class="fa-solid fa-bars"></i
    ></a>

    <!-- Header Menu -->
    <ul class="nav user-menu">
      <!-- Search -->
      <li class="nav-item gs-nav-item">
        <global-search />
      </li>
      <!-- /Search -->

      <!-- Theme Colors -->
      <li class="nav-item">
        <div class="theme-colors-section" role="group" aria-label="Theme colour">
          <button
            v-for="swatch in themeSwatches"
            :key="swatch.key"
            type="button"
            class="theme-swatch"
            :class="{ 'is-active': swatch.active }"
            :style="{ '--swatch': swatch.primary }"
            :title="swatch.active ? 'Current theme colour' : 'Switch theme colour'"
            :aria-label="'Theme colour ' + swatch.primary"
            :aria-pressed="swatch.active"
            @click="changeThemeColor(swatch.primary, swatch.secondary)"
          >
            <span class="theme-swatch__dot">
              <i v-if="swatch.active" class="fa-solid fa-check theme-swatch__check"></i>
            </span>
          </button>
        </div>
      </li>
      <!-- /Theme Colors -->

      <!-- Flag -->
      <li class="nav-item dropdown has-arrow flag-nav">
        <a-dropdown
          :trigger="['click']"
          placement="bottomLeft"
          :get-popup-container="getHeaderPopupContainer"
          overlay-class-name="header-user-overlay header-lang-overlay"
          :overlay-style="langMenuWidth ? { width: langMenuWidth + 'px' } : undefined"
          @openChange="onLangMenuOpenChange"
        >
          <a
            ref="langTrigger"
            href="javascript:;"
            class="nav-link lang-drop-trigger"
            @click.prevent
          >
            <img src="@/assets/img/flags/us.png" alt="Flag" height="20" />
            <span>English</span>
            <i class="fa-solid fa-chevron-down user-drop-caret ms-auto"></i>
          </a>
          <template #overlay>
            <a-menu>
              <!-- Every language currently opens the "Feature Unavailable" modal. -->
              <a-menu-item v-for="lang in languages" :key="lang.code">
                <a
                  href="javascript:void(0);"
                  data-bs-toggle="modal"
                  data-bs-target="#warning-alert-modal"
                >
                  <img :src="lang.flag" alt="Flag" height="16" />{{ lang.label }}
                </a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </li>
      <!-- /Flag -->

      <!-- Notifications -->
      <li class="nav-item">
        <a-dropdown
          v-model:open="notifDropdownOpen"
          :trigger="['click']"
          placement="bottomRight"
          :get-popup-container="getHeaderPopupContainer"
          overlay-class-name="header-notif-overlay"
        >
          <a
            href="javascript:;"
            class="nav-link header-notif-trigger"
            :class="{ 'is-open': notifDropdownOpen }"
            @click.prevent
          >
            <span class="header-notif-chip">
              <a-badge :count="unreadCount" :overflow-count="99">
                <i class="fa-solid fa-bell header-notif-bell-icon"></i>
              </a-badge>
            </span>
          </a>
          <template #overlay>
            <div class="header-notif-panel">
              <div class="header-notif-panel__header">
                <span class="header-notif-panel__title"
                  >Notifications
                  <span v-if="unreadCount" class="header-notif-panel__count">{{
                    unreadCount
                  }}</span>
                </span>
                <a
                  v-if="unreadCount"
                  href="javascript:;"
                  class="header-notif-panel__markall"
                  @click="markAllAsRead"
                  >Mark all as read</a
                >
              </div>
              <div class="header-notif-panel__body">
                <div
                  v-if="notificationsLoading && !notifications.length"
                  class="header-notif-loading"
                >
                  <a-spin size="small" />
                  <span>Loading…</span>
                </div>
                <a-list
                  v-else-if="notifications.length"
                  :data-source="notifications.slice(0, 5)"
                  item-layout="horizontal"
                >
                  <template #renderItem="{ item }">
                    <a-list-item class="header-notif-item">
                      <router-link
                        :to="notificationTarget(item)"
                        class="header-notif-item__link"
                        @click="() => onNotificationClick(item)"
                      >
                        <span class="header-notif-item__text">
                          <span class="header-notif-item__title-row">
                            <strong
                              v-if="item.title"
                              class="header-notif-item__title"
                              >{{ item.title }}</strong
                            >
                            <!-- <span
                              v-if="item.urgency"
                              class="status-badge status-badge--compact"
                              :class="`status-badge--urgency-${item.urgency}`"
                              >{{ item.urgency }}</span
                            > -->
                          </span>
                          <span
                            v-if="item.normalizedDescription"
                            class="header-notif-item__desc"
                            >{{ item.normalizedDescription }}</span
                          >
                          <span v-if="item.date" class="header-notif-item__date"
                            ><i class="fa-regular fa-clock"></i>{{ item.date }}</span
                          >
                        </span>
                      </router-link>
                    </a-list-item>
                  </template>
                </a-list>
                <a-empty
                  v-else
                  description="No notifications"
                  class="header-notif-empty"
                />
              </div>
              <div class="header-notif-panel__footer">
                <router-link to="/notifications" @click="notifDropdownOpen = false"
                  >View all notifications</router-link
                >
              </div>
            </div>
          </template>
        </a-dropdown>
      </li>
      <!-- /Notifications -->

      <li class="nav-item">
        <a-dropdown
          :trigger="['click']"
          placement="bottomRight"
          :get-popup-container="getHeaderPopupContainer"
          overlay-class-name="header-user-overlay"
          :open="userMenuOpen"
          @openChange="onUserMenuOpenChange"
        >
          <a href="javascript:;" class="nav-link user-drop-trigger" @click.prevent>
            <span class="user-img me-1 flex-shrink-0">
              <img
                v-if="this.$store?._state?.data?.auth?.user?.profile_picture"
                :src="this.$store?._state?.data?.auth?.user?.profile_picture"
                alt="User Image" />
              <img
                v-else
                src="@/assets/img/profiles/avatar-21.jpg"
                alt="User Image" />
              <span class="status online"></span
            ></span>
            <i class="fa-solid fa-chevron-down user-drop-caret"></i>
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item key="profile" :disabled="isLoggingOut">
                <router-link to="/employee/profile"
                  ><i class="fa-regular fa-user m-r-5"></i>My Profile</router-link
                >
              </a-menu-item>
              <a-menu-item key="password" :disabled="isLoggingOut">
                <router-link to="/change-password"
                  ><i class="fa-solid fa-key m-r-5"></i>Change Password</router-link
                >
              </a-menu-item>
              <a-menu-item key="two-factor-authentication" :disabled="isLoggingOut">
                <router-link to="/two-factor-authentication"
                  ><i class="fa-solid fa-shield-halved m-r-5"></i>Two Factor Authentication</router-link
                >
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item
                key="logout"
                class="header-user-menu__logout"
                @click="handleLogout"
              >
                <i
                  v-if="isLoggingOut"
                  class="fa-solid fa-spinner fa-spin m-r-5"
                ></i>
                <i v-else class="fa-solid fa-arrow-right-from-bracket m-r-5"></i
                >{{ isLoggingOut ? "Logging out..." : "Logout" }}
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:;"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa-solid fa-ellipsis-vertical"></i
      ></a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/employee/profile"
          >My Profile</router-link
        >
        <router-link class="dropdown-item" to="settings">Settings</router-link>
        <router-link
          class="dropdown-item"
          to="logout"
          @click.prevent="handleLogout"
          >{{ isLoggingOut ? "Logging out..." : "Logout" }}</router-link
        >
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

  <!-- Warning Alert Modal -->
  <div
    id="warning-alert-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body p-4">
          <div class="text-center">
            <i
              class="fa-solid text-warning fa-triangle-exclamation"
              style="font-size: 2rem"
            ></i>
            <h4 class="mt-2">Feature Unavailable</h4>
            <p class="mt-3">
              Sorry, your organization currently does not have access to this
              feature. Contact your administrator to learn more about enabling
              this feature.
            </p>
            <b-button variant="warning my-2" data-bs-dismiss="modal">
              Continue
            </b-button>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->

  <!-- <sidesettings></sidesettings> -->
</template>

<script>
import AuthService from "@/services/AuthService";
import LogoService from "@/services/LogoService";
import { ref } from "vue";
import { mapGetters } from "vuex";
import clientLogo from "@/assets/img/meri-sehat-logo.svg";
import { removeTawkTo, showApiError } from "@/utils";
import defaultLogo from '@/assets/img/client-logo.png'
import usFlag from "@/assets/img/flags/us.png";
import pkFlag from "@/assets/img/flags/pk.png";
import esFlag from "@/assets/img/flags/es.png";
import GlobalSearch from "@/components/GlobalSearch/GlobalSearch.vue";
import { applyThemeColors } from "@/utils/theme";

export default {
  components: { GlobalSearch },
  data() {
    return {
      isGlobalVariant: process.env.VUE_APP_VARIANT === "default",
      isAppedologyVariant: process.env.VUE_APP_VARIANT === "appedology",
      isProGlobalVariant: process.env.VUE_APP_VARIANT === "proglobal",
      miniSidebar: ref(false),
      notifDropdownOpen: false,
      languages: [
        { code: "en", label: "English", flag: usFlag },
        { code: "ur", label: "Urdu", flag: pkFlag },
        { code: "es", label: "Spanish", flag: esFlag },
      ],
      userMenuOpen: false,
      langMenuWidth: 0,
      activeThemeColor: "",
      isLoggingOut: false,
    };
  },
  methods: {
    // Make the language menu exactly as wide as its trigger box.
    onLangMenuOpenChange(open) {
      if (open && this.$refs.langTrigger) {
        this.langMenuWidth = this.$refs.langTrigger.offsetWidth;
      }
    },
    onUserMenuOpenChange(open) {
      // Keep the menu open while logging out so "Logging out..." stays visible.
      if (!open && this.isLoggingOut) return;
      this.userMenuOpen = open;
    },
    // Render antd overlays inside the fixed <div class="header"> instead of the
    // default <body>. <body> is document-scrolled, so an absolutely-positioned
    // overlay anchored to it drifts away from the bell/avatar as the page
    // scrolls. The header is position:fixed with overflow visible and z-index
    // 1002, so the panel stays glued to its trigger and isn't clipped.
    getHeaderPopupContainer() {
      return this.$refs.header || document.body;
    },
    // Notifications tied to a specific record (a leave request, etc.) carry
    // their own action.path to deep-link to. Generic ones (no action) fall
    // back to the notifications page, which opens this item's detail view
    // via the ?id= query param.
    notificationTarget(item) {
      return item.action?.path || `/notifications?id=${item.id}`;
    },
    async onNotificationClick(item) {
      this.notifDropdownOpen = false;
      if (!item.read_at) {
        try {
          await this.$store.dispatch("markAsRead", item.id);
        } catch (error) {
          showApiError(error, "Couldn't mark notification as read");
        }
      }
    },
    async markAllAsRead() {
      try {
        await this.$store.dispatch("markAllAsRead");
      } catch (error) {
        showApiError(error, "Couldn't mark all notifications as read");
      }
    },
    async handleLogout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      // The logout request needs the bearer token, so call the API first and
      // only clear the local session once it has finished.
      try {
        await AuthService.logout();
      } catch (error) {
        // Still sign the user out locally if the server call fails.
        console.error("Logout request failed", error);
      } finally {
        this.$store.dispatch("auth/resetState");
        removeTawkTo();
        localStorage.removeItem("token");
        localStorage.removeItem("model-wise-permissions");
        localStorage.removeItem("user");
        sessionStorage.clear();
        this.isLoggingOut = false;
        this.userMenuOpen = false;
        this.$router.push("/");
      }
    },
    toggleSidebar() {
      const body = document.body;
      const contentDiv = body.getElementsByClassName("content")[0];
      body.classList.toggle("mini-sidebar");
      contentDiv.classList.toggle(".mini-sidebar-content");
      this.miniSidebar = !this.miniSidebar;
    },
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    submitForm() {
      this.$router.push("/search");
    },
    // "#ff6634" / "rgb(255, 102, 52)" -> "#ff6634" so stored and CSS values compare.
    normalizeColor(value) {
      const v = String(value || "").trim().toLowerCase();
      const rgb = v.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/);
      if (rgb) {
        return "#" + rgb.slice(1, 4).map((n) => Number(n).toString(16).padStart(2, "0")).join("");
      }
      return v.length === 4 ? "#" + [...v.slice(1)].map((c) => c + c).join("") : v;
    },
    // Variant builds force their own brand colour (see App.vue getOrganizationTheme);
    // otherwise it's whatever the user last picked, falling back to the live CSS value.
    readActiveThemeColor() {
      let color;
      if (this.isProGlobalVariant) color = "#186997";
      else if (this.isAppedologyVariant) color = "#9E252E";
      else {
        try {
          color = localStorage.getItem("primary-color");
        } catch (e) {
          color = null;
        }
      }
      if (!color) {
        color = getComputedStyle(document.documentElement).getPropertyValue("--primary-color");
      }
      this.activeThemeColor = this.normalizeColor(color);
    },
    changeThemeColor(primaryColor, secondaryColor) {
      // Brand variants force their own colour at startup (App.vue), so a swatch
      // click only remembers the pick there, exactly as before.
      if (this.isAppedologyVariant || this.isProGlobalVariant) {
        localStorage.setItem("primary-color", primaryColor);
        localStorage.setItem("secondary-color", secondaryColor);
        return;
      }
      applyThemeColors(primaryColor, secondaryColor);
      this.activeThemeColor = this.normalizeColor(primaryColor);
    },
    updateClientThemeColor() {
      if (this.clientThemeColor) {
        document.documentElement.style.setProperty(
          "--client-theme-color",
          this.clientThemeColor,
        );
      }
    },
  },
  created() {
    this.readActiveThemeColor();
  },
  mounted() {
    // // Add scroll event listener
    // window.addEventListener("scroll", () => {
    //   var scroll = window.pageYOffset || document.documentElement.scrollTop;
    //   var header = document.getElementsByClassName("header")[0];

    //   if (scroll < 100) {
    //     header.classList.remove("sticky");
    //   } else {
    //     header.classList.add("sticky");
    //   }
    // });

    this.updateClientThemeColor();

    // Add click event listener
    this.$nextTick(() => {
      document.addEventListener("click", this.handleToggleClick);
    });

    // Add mouseover event listener
    document.addEventListener("mouseover", (event) => {
      event.stopPropagation();

      var body = document.body;
      var toggleBtn = document.getElementById("toggle_btn");
      var sidebar = document.getElementsByClassName("sidebar")[0];
      var subdropUL = document.getElementsByClassName("subdrop");

      if (
        body.classList.contains("mini-sidebar") &&
        toggleBtn.style.display !== "none"
      ) {
        var target = event.target.closest(".sidebar");

        if (target) {
          body.classList.add("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "block";
            }
          }
        } else {
          body.classList.remove("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "none";
            }
          }
        }

        event.preventDefault();
      }
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleToggleClick);
  },
  computed: {
    // Same colours / visibility rules the header always had, now data-driven so
    // the active one can be highlighted.
    themeSwatches() {
      const client = this.clientThemeColor;
      const list = [
        { key: "organization", show: this.isAppedologyVariant, primary: "#9E252E", secondary: "rgba(158, 37, 46, 0.55)" },
        { key: "proglobal", show: this.isProGlobalVariant, primary: "#186997", secondary: "rgba(24,105,151,0.55)" },
        { key: "primary", show: true, primary: "#FF6634", secondary: "rgba(255, 102, 52, 0.55)" },
        {
          key: "secondary",
          show: !this.isAppedologyVariant,
          primary: client || "#EC048E",
          secondary: client ? client + "8c" : "rgba(236, 4, 142, 0.55)",
        },
        { key: "tertiary", show: true, primary: "#008080", secondary: "rgba(0, 128, 128, 0.55)" },
        { key: "quaternary", show: !this.isProGlobalVariant, primary: "#01CCFF", secondary: "rgba(1, 204, 255, 0.55)" },
      ];
      return list
        .filter((sw) => sw.show)
        .map((sw) => ({ ...sw, active: this.normalizeColor(sw.primary) === this.activeThemeColor }));
    },
    ...mapGetters("auth", ["userRole"]),
    ...mapGetters("auth", ["userName"]),
    ...mapGetters({
      notifications: "unreadNotifications",
      unreadCount: "unreadCount",
      notificationsLoading: "notificationsLoading",
    }),
    appVariant() {
      return process.env.VUE_APP_VARIANT || "default";
    },
    logo() {
      return this.$store.getters["system/systemLogo"];
    },
    logoSrc() {
      return this.logo || defaultLogo;
    },
    clientThemeColor() {
      return this.$store.getters["system/primaryColor"];
    },
  },
};
</script>

<style scoped>
/* Theme colour picker. A rounded pill of flat swatches: a faint tint of the colour
   behind a solid dot. Active = one crisp ring in the swatch colour + a check.
   No gloss, glow or halo on purpose. */
.header .theme-colors-section {
  height: 38px;
  gap: 6px;
  padding: 0 10px;
  margin: 0 8px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: none;
}

.theme-swatch {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: color-mix(in srgb, var(--swatch) 10%, #fff);
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.theme-swatch__dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--swatch);
  transition: width 0.15s ease, height 0.15s ease;
}

.theme-swatch:hover {
  background: color-mix(in srgb, var(--swatch) 18%, #fff);
}

.theme-swatch:active .theme-swatch__dot {
  width: 14px;
  height: 14px;
}

.theme-swatch:focus-visible {
  outline: 2px solid var(--swatch);
  outline-offset: 2px;
}

.theme-swatch.is-active {
  cursor: default;
  box-shadow: inset 0 0 0 1px var(--swatch);
}

/* .theme-swatch.is-active .theme-swatch__dot {
  width: 15px;
  height: 15px;
} */

.theme-swatch__check {
  font-size: 7px;
  line-height: 1;
  color: #fff;
}

@media (prefers-reduced-motion: reduce) {
  .theme-swatch,
  .theme-swatch__dot {
    transition: none;
  }
}

.user-drop-trigger {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}

/* Header background is actually light, not the colored gradient the SCSS
   source implies (that stylesheet isn't even wired into the build) — a
   white glyph here is invisible. Muted dark gray, same as the bell icon.
   !important because a global ".user-menu > li > a i" rule (20px, from the
   compiled site-wide stylesheet) otherwise outranks this scoped selector
   on specificity and silently wins. */
.user-drop-caret {
  font-size: 9px !important;
  line-height: 1 !important;
  width: auto !important;
  color: #6b7280;
  transition: color 0.15s ease;
}

.user-drop-trigger:hover .user-drop-caret {
  color: #374151;
}

/* Language selector mirrors the global search box (.gs-trigger): same
   translucent white fill, border, radius, text size and hover glow. */
.header .user-menu.nav > li.flag-nav {
  width: 150px;
  height: auto;
  background: transparent;
}

.lang-drop-trigger {
  display: flex !important;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 38px !important;
  line-height: normal !important;
  padding: 0 14px !important;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  color: #6b7280 !important;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.lang-drop-trigger:hover,
.ant-dropdown-open.lang-drop-trigger {
  border-color: var(--primary-color, #4f46e5);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
}

.lang-drop-trigger span {
  flex: 1;
  font-size: 13px;
  color: #6b7280;
}

.lang-drop-trigger img {
  width: 16px !important;
  height: 16px !important;
  margin-right: 0 !important;
}

.lang-drop-trigger .user-drop-caret {
  font-size: 10px !important;
  line-height: normal !important;
  color: #6b7280;
}

/* Icon sits inside a 60px-tall nav-link whose line-height (inherited from
   .user-menu > li > a i) stretches the icon's own box to 60px, which pushed
   the ant-badge dot — anchored to that box's corner — far above the glyph.
   Centering with flex + collapsing the icon's line-height keeps the badge
   snug against the bell instead. */
.header-notif-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}

/* Chip echoes GlobalSearch's ".gs-trigger" treatment: a soft translucent
   circle sitting on the header gradient, so the icon can be a muted gray
   instead of stark white and still stay readable. */
.header-notif-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(4px);
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.header-notif-trigger:hover .header-notif-chip,
.header-notif-trigger.is-open .header-notif-chip {
  background: #fff;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

.header-notif-trigger:focus-visible .header-notif-chip {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.header-notif-bell-icon {
  font-size: 15px;
  line-height: 1;
  color: #6b7280;
  transition: color 0.15s ease;
}

.header-notif-trigger:hover .header-notif-bell-icon,
.header-notif-trigger.is-open .header-notif-bell-icon {
  color: #374151;
}

.header-notif-chip :deep(.ant-badge) {
  display: inline-flex;
  line-height: 1;
}

/* Anchored directly to the icon's own box (transform disabled) instead of
   antd's default translate(50%,-50%), which — against such a small icon —
   read as a large gap between the bell and the count. */
.header-notif-chip :deep(.ant-badge-count) {
  top: 10px;
  right: -5px;
  transform: none;
  min-width: 15px;
  height: 15px;
  line-height: 15px;
  font-size: 10px;
  font-weight: 700;
  padding: 0 4px;
  background: var(--primary-color, #ff6634);
  box-shadow: 0 0 0 1.5px #fff;
}
</style>

<style>
/* Overlay is teleported outside this component, so these rules are global. */
.header-notif-overlay {
  z-index: 1060;
}

.header-user-overlay {
  z-index: 1060;
}

.header-user-overlay .ant-dropdown-menu {
  width: max-content !important;
  min-width: 0 !important;
  max-width: 220px;
  padding: 3px;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14);
}

/* Language menu only: fill the popup, whose width is set from the trigger box. */
.header-user-overlay.header-lang-overlay .ant-dropdown-menu {
  width: 100% !important;
  max-width: none;
}

.header-user-overlay .ant-dropdown-menu-item {
  border-radius: 5px;
  padding: 0;
  min-height: 0;
  line-height: 1.2;
}

.header-user-overlay .ant-dropdown-menu-item > a,
.header-user-overlay .ant-dropdown-menu-item > .ant-dropdown-menu-title-content {
  display: flex;
  align-items: flex-start;
  white-space: normal;
  overflow-wrap: anywhere;
  padding: 4px 8px;
  color: #26292c;
  font-size: 12.5px;
  line-height: 1.3;
}

.header-user-overlay .ant-dropdown-menu-item i {
  width: 13px;
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 11px;
  color: #999;
}

.header-user-overlay .ant-dropdown-menu-item img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
  margin-top: 1px;
}

.header-user-overlay .ant-dropdown-menu-item:hover {
  background: #f9f9fb;
}

.header-user-overlay .header-user-menu__logout,
.header-user-overlay .header-user-menu__logout > .ant-dropdown-menu-title-content {
  color: #cf1322;
}

.header-user-overlay .header-user-menu__logout i {
  color: #cf1322;
}

/* Declared after the generic item hover so it wins the tie-break — same
   specificity, later source order. */
.header-user-overlay .header-user-menu__logout:hover {
  background: #fff1f0;
}

.header-user-overlay .ant-dropdown-menu-item-divider {
  margin: 4px 0;
}

.header-notif-panel {
  width: 360px;
  max-width: 90vw;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14);
  overflow: hidden;
}

.header-notif-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #f0f0f0;
}

.header-notif-panel__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #26292c;
}

.header-notif-panel__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--primary-color, #ff6634);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.header-notif-panel__markall,
.header-notif-panel__markall:hover {
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color, #ff6634);
  white-space: nowrap;
}

.header-notif-panel__markall:hover {
  text-decoration: underline;
}

.header-notif-panel__markall:focus-visible {
  outline: 2px solid var(--primary-color, #ff6634);
  outline-offset: 2px;
  border-radius: 4px;
}

.header-notif-panel__body {
  max-height: 360px;
  overflow-y: auto;
}

.header-notif-item {
  padding: 0 !important;
  border-block-end: 1px solid #f5f5f5 !important;
}

.header-notif-item:last-child {
  border-block-end: none !important;
}

.header-notif-item__link {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 12px 18px;
  color: inherit;
  transition: background 0.15s ease;
}

.header-notif-item__link:hover {
  background: #f9f9fb;
}

.header-notif-item__link:focus-visible {
  outline: 2px solid var(--primary-color, #ff6634);
  outline-offset: -2px;
  background: #f9f9fb;
}

.header-notif-item__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.header-notif-item__title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-notif-item__title {
  min-width: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #26292c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .status-badge / .status-badge--urgency-* live in
   src/assets/css/notification-badges.css, shared with notifications.vue. */
.status-badge.status-badge--compact {
  flex-shrink: 0;
}

.header-notif-item__desc {
  font-size: 12px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.header-notif-item__date {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #999;
  margin-top: 2px;
}

.header-notif-item__date i {
  font-size: 10px;
}

.header-notif-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 32px 18px;
  justify-content: center;
  color: #666;
  font-size: 13px;
}

.header-notif-empty {
  padding: 28px 16px;
}

.header-notif-panel__footer {
  padding: 11px 16px;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.header-notif-panel__footer a,
.header-notif-panel__footer a:hover {
  font-size: 13px;
  font-weight: 600;
  color: var(--primary-color, #ff6634);
}

.header-notif-panel__footer a:hover {
  text-decoration: underline;
}

.header-notif-panel__footer a:focus-visible {
  outline: 2px solid var(--primary-color, #ff6634);
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
